import { SET_PROJECTS, SET_SELECTED_PROJECT, UNSET_PROJECT, UNSET_SELECTED_PROJECT } from "../actions/types";

const initialState = {
  all: [],
  selected: {
    donors: [],
    users: [],
    assets: [],
    attachments: [],
  },
};

export function project(state = initialState, action = {}) {
  switch (action.type) {
    case SET_PROJECTS:
      return Object.assign({}, state, { all: action.projects });
    case SET_SELECTED_PROJECT:
      return Object.assign({}, state, { selected: action.project });
    case UNSET_PROJECT:
      return Object.assign({}, state, {
        all: state.all.filter((p) => p.id !== action.project),
      });
    case UNSET_SELECTED_PROJECT:
      return Object.assign({}, state, {
        selected: {
          donors: [],
          users: [],
          assets: [],
          attachments: [],
        },
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/project.js